module.exports = __webpack_public_path__ + "images/8cc1c288f24185c473b9556b602c8441.png";